import React from 'react'
import { Box, Flex, VStack, Text, Divider, Skeleton } from '@chakra-ui/react'
import ProcessOrder from './ProcessOrder'

type Props = { 
  order: any
}

export default function PreviewOrderSummary({ order }: Props){
  let options = [
    { 
      label: 'Confirm', 
      value: 'confirmed', 
      id: 1 
    },
    { 
      label: 'Ship For Delivery', 
      value: 'outForDelivery', 
      id: 2 
    },
    {   
      label: 'Complete', 
      value: 'completed', 
      id: 3 
    },
    { 
      label: 'Cancel', 
      value: 'canceled', 
      id: 4 
    }
  ]

  options = options.filter((option) => {
    if (order.status === 'placed') {
      return option.value !== 'outForDelivery' && option.value !== 'completed';
    } else if (order.status === 'confirmed'){
      return option.value !== 'confirmed' && option.value !== 'completed';
    } else if (order.status === 'outForDelivery') {
      return option.value !== 'confirmed' && option.value !== 'outForDelivery';
    } else if (order.status === 'completed' || order.status === 'canceled') {
      return false;
    }
    return true; // Include all options for other order statuses
  });

  return (
    <Box
      p='5' boxShadow='md' borderRadius='8' maxW='50rem' mx='auto' w='100%'
    >
      <Box>
        <Text fontWeight='bold' fontSize='xl' color='gray.500'>
          #Order ID: {order._id}
        </Text>
      </Box>

      <Divider border='1px' borderColor='gray.500' mt={3} />

      <VStack w='full' mt={5}>
        <Flex w='full' justifyContent='space-between'>
          <Box>
            <Text fontWeight='semibold' fontSize='lg' color='gray.500'>
              Customer name
            </Text>
          </Box>

          <Box>
            <Text fontWeight='bold' fontSize='lg' color='pink.500'>
              {order.customer.firstName} {order.customer.lastName}
            </Text>
          </Box>
        </Flex>

        <Flex w='full' justifyContent='space-between'>
          <Box>
            <Text fontWeight='semibold' fontSize='lg' color='gray.500'>
              Email
            </Text>
          </Box>

          <Box>
            <Text fontWeight='bold' fontSize='lg' color='blue.500'>
              {order.customer.email}
            </Text>
          </Box>
        </Flex>

        <Flex w='full' justifyContent='space-between'>
          <Box>
            <Text fontWeight='semibold' fontSize='lg' color='gray.500'>
              Phone number
            </Text>
          </Box>

          <Box>
            <Text fontWeight='bold' fontSize='lg' color='green.500'>
              {order.customer.phone_number}
            </Text>
          </Box>
        </Flex>

        <Flex w='full' justifyContent='space-between'>
          <Box>
            <Text fontWeight='semibold' fontSize='lg' color='gray.500'>
              Shipping address
            </Text>
          </Box>

          <Box>
            <Text fontWeight='bold' fontSize='lg' color='yellow.500'>
              {order.customer.shipping_address}
            </Text>
          </Box>
        </Flex>
      </VStack>

      <Divider border='1px' borderColor='gray.500' mt={3} />

      <VStack w='full' mt={5}>
        <Flex w='full' justifyContent='space-between'>
          <Box>
            <Text fontWeight='semibold' fontSize='lg' color='gray.500'>
              Current status
            </Text>
          </Box>

          <Box>
            <Text fontWeight='bold' fontSize='lg' color='purple.500'>
              {order.status.toUpperCase()}
            </Text>
          </Box>
        </Flex>

        <Flex w='full' justifyContent='space-between'>
          <Box>
            <Text fontWeight='semibold' fontSize='lg' color='gray.500'>
              Payment method
            </Text>
          </Box>

          <Box>
            <Text fontWeight='bold' fontSize='lg' color='red.500'>
              {order.payment_method.toUpperCase()}
            </Text>
          </Box>
        </Flex>

        <Flex w='full' justifyContent='space-between'>
          <Box>
            <Text fontWeight='semibold' fontSize='lg' color='gray.500'>
              Payment provider
            </Text>
          </Box>

          <Box>
            <Text fontWeight='bold' fontSize='lg' color='green.500'>
              {order.payment_provider.toUpperCase()}
            </Text>
          </Box>
        </Flex>

        <Flex w='full' justifyContent='space-between'>
          <Box>
            <Text fontWeight='semibold' fontSize='lg' color='gray.500'>
              Shipping fee
            </Text>
          </Box>

          <Box>
            <Text fontWeight='bold' fontSize='lg' color='orange.500'>
              ₦{order.shipping_fee}
            </Text>
          </Box>
        </Flex>

        <Flex w='full' justifyContent='space-between'>
          <Box>
            <Text fontWeight='semibold' fontSize='lg' color='gray.500'>
              Order total
            </Text>
          </Box>

          <Box>
            <Text fontWeight='bold' fontSize='lg' color='blue.500'>
              ₦{order.amount}
            </Text>
          </Box>
        </Flex>

        <Flex w='full' justifyContent='space-between'>
          <Box>
            <Text fontWeight='semibold' fontSize='lg' color='gray.500'>
              Paid
            </Text>
          </Box>

          <Box>
            <Text fontWeight='bold' fontSize='lg' color='green.500'>
              {order.paid ? 'YES' : "NO"}
            </Text>
          </Box>
        </Flex>

        {order.reference &&
          <Flex w='full' justifyContent='space-between'>
            <Box>
              <Text fontWeight='semibold' fontSize='lg' color='gray.500'>
                Reference
              </Text>
            </Box>

            <Box>
              <Text fontWeight='bold' fontSize='lg' color='purple.500'>
                {order.reference}
              </Text>
            </Box>
          </Flex>
        }

        <Flex w='full' justifyContent='space-between'>
          <Box>
            <Text fontWeight='semibold' fontSize='lg' color='gray.500'>
              Date placed
            </Text>
          </Box>

          <Box>
            <Text fontWeight='bold' fontSize='lg' color='yellow.500'>
              {order.date_placed}
            </Text>
          </Box>
        </Flex>
      </VStack>

      <Divider border='1px' borderColor='gray.500' mt={3} />

      <Box mt={5}>
        <Text fontWeight='bold' fontSize='xl' color='gray.500'>
          PROCESS ORDER
        </Text>
      </Box>

      <Box mt={3}>
        <ProcessOrder 
          order_id={order._id}
          options={options}
        />
      </Box>
    </Box>
  )
}

export function PreviewOrderSummarySkeletion(){
  return (
    <Box
      p='5' boxShadow='md' borderRadius='8' maxW='50rem' mx='auto' w='100%'
    >
      <Skeleton h='16px' w='50%' />

      <Divider border='1px' borderColor='gray.500' mt={3} />

      <VStack w='full' spacing={4} mt={5}>
        <Flex w='full' justifyContent='space-between'>
          <Box>
            <Skeleton h='16px' w='10rem' />
          </Box>

          <Box>
            <Skeleton h='16px' w='15rem' />
          </Box>
        </Flex>

        <Flex w='full' justifyContent='space-between'>
          <Box>
            <Skeleton h='16px' w='12rem' />
          </Box>

          <Box>
            <Skeleton h='16px' w='13rem' />
          </Box>
        </Flex>

        <Flex w='full' justifyContent='space-between'>
          <Box>
            <Skeleton h='16px' w='8rem' />
          </Box>

          <Box>
            <Skeleton h='16px' w='10rem' />
          </Box>
        </Flex>

        <Flex w='full' justifyContent='space-between'>
          <Box>
            <Skeleton h='16px' w='9rem' />
          </Box>

          <Box>
            <Skeleton h='16px' w='11rem' />
          </Box>
        </Flex>
      </VStack>

      <Divider border='1px' borderColor='gray.500' mt={3} />

      <VStack w='full' spacing={4} mt={5}>
        <Flex w='full' justifyContent='space-between'>
          <Box>
            <Skeleton h='16px' w='10rem' />
          </Box>

          <Box>
            <Skeleton h='16px' w='15rem' />
          </Box>
        </Flex>

        <Flex w='full' justifyContent='space-between'>
          <Box>
            <Skeleton h='16px' w='12rem' />
          </Box>

          <Box>
            <Skeleton h='16px' w='13rem' />
          </Box>
        </Flex>

        <Flex w='full' justifyContent='space-between'>
          <Box>
            <Skeleton h='16px' w='8rem' />
          </Box>

          <Box>
            <Skeleton h='16px' w='10rem' />
          </Box>
        </Flex>

        <Flex w='full' justifyContent='space-between'>
          <Box>
            <Skeleton h='16px' w='9rem' />
          </Box>

          <Box>
            <Skeleton h='16px' w='11rem' />
          </Box>
        </Flex>
      </VStack>

      <Divider border='1px' borderColor='gray.500' mt={3} />

      <VStack w='full' spacing={4} mt={5}>
        <Flex w='full' justifyContent='space-between'>
          <Box>
            <Skeleton h='16px' w='10rem' />
          </Box>

          <Box>
            <Skeleton h='16px' w='15rem' />
          </Box>
        </Flex>

        <Flex w='full' justifyContent='space-between'>
          <Box>
            <Skeleton h='16px' w='12rem' />
          </Box>

          <Box>
            <Skeleton h='16px' w='13rem' />
          </Box>
        </Flex>

        <Flex w='full' justifyContent='space-between'>
          <Box>
            <Skeleton h='16px' w='8rem' />
          </Box>

          <Box>
            <Skeleton h='16px' w='10rem' />
          </Box>
        </Flex>

        <Flex w='full' justifyContent='space-between'>
          <Box>
            <Skeleton h='16px' w='9rem' />
          </Box>

          <Box>
            <Skeleton h='16px' w='11rem' />
          </Box>
        </Flex>
      </VStack>

      <Divider border='1px' borderColor='gray.500' mt={3} />

      <VStack w='full' spacing={4} mt={5}>
        <Flex w='full' justifyContent='space-between'>
          <Box>
            <Skeleton h='16px' w='10rem' />
          </Box>

          <Box>
            <Skeleton h='16px' w='15rem' />
          </Box>
        </Flex>

        <Flex w='full' justifyContent='space-between'>
          <Box>
            <Skeleton h='16px' w='12rem' />
          </Box>

          <Box>
            <Skeleton h='16px' w='13rem' />
          </Box>
        </Flex>

        <Flex w='full' justifyContent='space-between'>
          <Box>
            <Skeleton h='16px' w='8rem' />
          </Box>

          <Box>
            <Skeleton h='16px' w='10rem' />
          </Box>
        </Flex>

        <Flex w='full' justifyContent='space-between'>
          <Box>
            <Skeleton h='16px' w='9rem' />
          </Box>

          <Box>
            <Skeleton h='16px' w='11rem' />
          </Box>
        </Flex>
      </VStack>
    </Box>
  )
}